import { Link } from "@tanstack/react-router";

import { useRole } from "@/utils/hooks/use-role";
import type { Role } from "@/utils/hooks/use-role";

import type { LinkProps } from "@tanstack/react-router";

type RoleLinkProps = Omit<LinkProps, "params"> & {
  // Optional: allow overriding role for a single link
  roleOverride?: Role;
  className?: string;
};

export function RoleLink({ roleOverride, ...rest }: RoleLinkProps) {
  const role = roleOverride ?? useRole();
  return <Link {...rest} params={{ role }} />;
}
